import {
  ArrowTopRightOnSquareIcon,
  ChevronRightIcon,
} from '@heroicons/react/20/solid';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

import { AppShellNavItem } from '@/utils/app-shell/getAppShellNavItems';

type AccountMenuItemTarget = { to: string } | { href: string };

export type AccountMenuItemProps = AccountMenuItemTarget & {
  icon: AppShellNavItem['icon'];
  label: string;
  className?: string;
  onClick?(): void;
};

export default function AccountMenuItem({
  icon: Icon,
  label,
  className,
  onClick,
  ...target
}: AccountMenuItemProps) {
  const classes = twMerge(
    'flex w-full items-center gap-3 rounded-xl px-4 py-3 text-sm text-base-content hover:bg-base-300',
    className,
  );

  const content = (
    <Fragment>
      <span className="flex size-9 shrink-0 items-center justify-center rounded-lg bg-base-300">
        <Icon className="size-6" strokeWidth={1} />
      </span>
      <span className="min-w-0 flex-1 truncate">{label}</span>
    </Fragment>
  );

  if ('href' in target) {
    return (
      <a
        href={target.href}
        target="_blank"
        rel="noopener noreferrer"
        className={classes}
        onClick={onClick}
      >
        {content}
        <ArrowTopRightOnSquareIcon className="size-5 shrink-0" />
      </a>
    );
  }

  return (
    <Link to={target.to} className={classes} onClick={onClick}>
      {content}
      <ChevronRightIcon className="size-5 shrink-0" />
    </Link>
  );
}
